var imgInfo = [
  {
    utype: 'icon',
    message: '20*20像素，50kb以下，jpg或png格式。如不填，默认显示黑色圆点。',
    imgSize: 50,
    width: 20,
    height: 20
  },
  {
    utype: 'category',
    message: '大小100kb内，80*80像素，方形，jpg、jpeg或png格式',
    imgSize: 100,
    width: 80,
    height: 80
  },
  {
    utype: 'common',
    message: '大小100kb内，80*80像素，方形，jpg、jpeg或png格式',
    imgSize: 100,
    width: 80,
    height: 80
  },
  {
    utype: 'banner',
    message: '大小500kb内，750*250像素，jpg、jpeg或png格式',
    imgSize: 500,
    width: 750,
    height: 250
  },
  {
    utype: 'banners',
    message: '大小500kb内，710*350像素，jpg、jpeg或png格式',
    imgSize: 500,
    width: 710,
    height: 350
  },
  {
    utype: 'eject',
    message: '大小500kb内，500*800像素，jpg、jpeg或png格式',
    imgSize: 500,
    width: 500,
    height: 800
  },
  {
    utype: 'promoIndex',
    message:
      '建议使用宽度750像素、高度小于等于250像素,大小500kb的图片,格式为：JPG、JEPG、GIF、PNG；',
    imgSize: 500,
    width: 750,
    height: 250,
    widthUse: '300px',
    heightUse: '190px'
  },
  {
    utype: 'categoryBanner',
    message: '大小500kb内，710*170像素，jpg、jpeg或png格式',
    imgSize: 500,
    width: 710,
    height: 170
  },
  {
    utype: 'ad',
    message: '大小500kb内，50*50像素，jpg、jpeg或png格式',
    imgSize: 100,
    width: 50,
    height: 50
  },
  {
    utype: 'label',
    message:
      '建议大小100kb内，50*50像素圆形透明背景或70*25像素圆角长方形透明背景，jpg、gif、jpge、png格式',
    imgSize: 100,
    width: 50,
    height: 50,
    widths: 70,
    heights: 25
  },
  {
    utype: 'promoImg',
    message:
      '建议使用宽度750像素、高度小于等于960像素,大小500kb的图片;格式为：JPG、JEPG、GIF、PNG',
    imgSize: 500,
    width: 750,
    height: 960,
    heightUse: '532px',
    widthUse: '300px'
  },
  {
    utype: 'fullScreen',
    // message:
    //   '建议使用宽度1920像素、高度小于等于1080像素,大小2M的图片;格式为： JPG、JEPG、GIF、PNG',
    imgSize: 2048,
    width: 1920,
    height: 1080,
    heightUse: '600px',
    widthUse: '300px'
  }
]
export default {
  imgInfo
}
